import './SalesforceSetupPanel.scss';

import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Button } from 'antd';
import { useAction } from '@hooks';

import { coreActions, OrganizationMetadata } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';

export interface SalesforceOrgSyncSecurityAlertsControlsProps {
	organization?: OrganizationMetadata;
}

export const SalesforceOrgSyncSecurityAlertsControls: React.FC<SalesforceOrgSyncSecurityAlertsControlsProps> = ({
	organization
}) => {

	const startSyncSecurityAlerts = useAction(coreActions.requestPostCoreSyncSecurityAlerts);

	const handleSyncSecurityAlerts = useCallback(() => {
		if (organization) {
			startSyncSecurityAlerts({
				organizationId: organization.id
			});
		}
	}, [ startSyncSecurityAlerts, organization ]);

	return organization ?
		<div>
			<Button
				className='sync-security-alerts-button'
				onClick={ handleSyncSecurityAlerts }>
				{ ADMIN_DASHBOARD_COPY.SYNC_SECURITY_ALERTS }
			</Button>
		</div> :
	 null;
};
